module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_vestfold_telemark_neg.826d5c3c.pdf";